module.exports = "<div class=\"content\">\n  <ng-content></ng-content>\n</div>\n<div class=\"checkbox\">\n  <i *ngIf=\"checked\" class=\"fa fa-check\" aria-hidden=\"true\"></i>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/checkbox/checkbox.component.html
// module id = 489
// module chunks = 1